export default __webpack_public_path__ + "static/chocpops-health-1-desktop-43b79fc8f3c50604321c9bb4b15a1775.png";